import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { Users } from "lucide-react";

import { formatGameTime } from "../format/formatGameTime";
import { formatList } from "../format/formatList";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";
import { IconBadge } from "./IconBadge";

const TITLE = msg({
  id: "finding.missed_teamfight",
  message: "{count, plural, one {# teamfight} other {# teamfights}} without you",
});

const DETAILS = msg({
  id: "finding.missed_teamfight.details",
  message:
    "Allies died in fights far from you: {fights}. When the team is about to fight, join it.",
});

const FIGHT = msg({
  id: "finding.missed_teamfight.fight",
  message: "{time} ({allies, plural, one {# ally} other {# allies}})",
});

// Союзники погибали в драках, а игрок был далеко.
export const MissedTeamfight = ({ finding, variant }: FindingProps<"missed_teamfight">) => {
  const { i18n } = useLingui();
  const { fights } = finding.params;
  const list = formatList(
    fights.map((fight) =>
      i18n._({
        ...FIGHT,
        values: { time: formatGameTime(fight.time_s), allies: fight.allies_died },
      }),
    ),
    i18n.locale,
  );
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<IconBadge icon={Users} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { count: fights.length } })}
      details={i18n._({ ...DETAILS, values: { fights: list } })}
      summary={formatList(
        fights.map((fight) => formatGameTime(fight.time_s)),
        i18n.locale,
      )}
    />
  );
};
